const page = `

{settings}
document.title: Nu slutar Mr. Text-tv
og.title: Nu slutar Mr. Text-tv
og.image: http://quickshot.imgix.net/texttv/delningsbild.jpg?w=1200&auto=format&q=45&cs=tinysrgb
og.twitterImage: http://quickshot.imgix.net/texttv/delningsbild.jpg?w=120&h=120&fit=crop&auto=format&q=45&cs=tinysrgb&fp-x=0.2
og.description: Torbjörn Jacobsson om supersuccén med sidan 377,  mordet på John Lennon, "Guds hand" – och när SVT tog livet av påven Johannes Paulus II
og.url: http://pejl.svt.se/nu-slutar-mr-text-tv
siteCatalyst.name: nu-slutar-mr-text-tv
siteCatalyst.category: lyxartikel
{}
[+page]
{.bild}
fil: texttv/texttvbild2.png
storlek: fullwide
{}
ingressmulti: [100]. [300]. [377].
ingressmulti: Många fattar direkt. Andra ser bara lite siffror, inte mer med det. För några få personer betyder det otroligt mycket mer än så.
ingressmulti: Fråga bara Torbjörn Jacobsson. I nästan 40 år (!) har han skrivit nyheterna som miljontals svenskar läst på text-tv. Men som alla stora epoker här även den här ett slut - den 30 april går Mr. text-tv i pension.
ingressmulti: Det här är hans berättelse om hur SVT Text växte fram och blev Sveriges största massmedium – och hur han själv blev en av landets mest lästa journalister.

{.sharebuttons}
title:Nu slutar Mr. Text-tv
url: http://pejl.svt.se/nu-slutar-mr-text-tv
{}

Vi börjar med lite siffror. Varje månad använder sig 42 procent av Sveriges befolkning av text-tv, i genomsnitt. Varje dag är det 21 procent av alla de som är mellan nio och 79 år. SVT:s text-tv har i dag runt två miljoner läsare dagligen.
Tittar man på rekordåren var de smått osannolika.
Under den riktiga storhetstiden på 1990- och början av 2000-talet räknade SVT att text-tv hade runt tre miljoner läsare – varje dag.

mellanrubrik: En av Sveriges mest lästa
Har man då jobbat fem dagar i veckan i bortemot 40 år med att skriva nyheter för text-tv, då har man också blivit läst. Av många. Möjligen haltar den här matematiken något, men man kan med ganska stor säkerhet konstatera:
Torbjörn Jacobsson är en av Sveriges mest lästa journalister genom alla tider.

{.bild}
fil: texttv/torbjorn_ny.jpg
bildtext: I bortemot 40 år har Torbjörn Jacobsson jobbat med text på Sveriges Television och han är en av Sveriges mest lästa journalister genom alla tider.
foto: Stina Stjernkvist
storlek: wide
{}

- Det är klart att det ger en viss stilla tillfredsställelse, säger Torbjörn lite blygsamt.
För berömmelse och gigantiska bildbylines är aldrig något som lockat Mr. text-tv.
Tvärtom.
- Jag ser mig mer som en anonym spelare i ett lag. Text-tv är ett anonymt medium och det passar mig, säger han, samtidigt som han vill lyfta fram flera andra pionjärer inom text-tv: Grundaren Åke "Bob" Holmberg, legendaren Björn Grundel och den ovärderliga allt-i-allon Birgitta Ihren.
luft:
{.bild}
fil: texttv/Pionjaerer.jpg
bildtext: Pionjärer. Från vänster Conny Johansson (textare), Inger Sjöstrand (textare) Björn Grundel (redaktör m.m.), Åke "Bob" Holmberg (text-tv-grundare och chef), Anders O Sundquist (tekniskt sakkunnig), Birgitta Ihren (sekreterare och allt-i-allo). Bilden troligen tagen 1979.
foto: Torbjörn Jacobsson
storlek: panorama
imgix.fp-y:0.1
{}

I Sverige började text-tv sändas den 12 mars 1979. Ett år senare, 1980, blev Torbjörn Jacobsson anställd på Sveriges Television.
– Nu kan jag nästan känna att det är lite retfullt att jag inte var med från den absoluta början, säger Torbjörn med ett litet skratt.

{.video}
id: 13424768
bildtext: När text-tv startade fanns bara 18.000 tv-apparater, som kunde ta emot text-tv, i hela Sverige. Då var det inte många som kunde ana vilken osannolik succé det skulle bli.
{}

Men riktigt så kände han inte då, i november 1980.
 – Jag var i vikariesvängen och hade jobbat lite på olika nyhetsbyråer, som AP och TT. Samtidigt som jag pluggade jobbade jag extra som spärrvakt och kom ofta till anställningsintervjuerna i min SL-uniform. Det fick man höra ett tag, berättar han.

mellanrubrik: Det vi gjorde var revolutionerande

När Torbjörn anställdes bestod avdelningen av åtta personer inklusive de som jobbade med undertextning. I början var det mest tänkt som ett hjälpmedel för hörselskadade och SVT var världsledande på den tiden.
 – När jag började fanns det bara 18.000 tv-apparater, som kunde ta emot text-tv, i hela Sverige. I dag ser vi sådant här överallt, varje dag, men det vi gjorde då var något helt nytt. Snudd på revolutionerande, säger Torbjörn.

{.citat}
citat: När jag började fanns det bara 18.000 tv-apparater, som kunde ta emot text-tv, i hela Sverige
stil: strong
av: Torbjörn Jacobsson
{}

De första 14 åren gjorde han det mesta på text-tv. Han var vikarierande nyhetsredaktör och SVT:s förste sportredaktör.
 – Det var jag och en till som bevakade OS i Los Angeles dygnet runt, det var extremt roligt och sanslöst mycket övertid, berättar han.
Däremot har han aldrig varit text-tv-chef i formell mening, något han erkänner att han gärna haft på sitt cv.
 – Men jag var ansvarig för utvecklingen. Det var jag som stod för uppdelningen av sidorna. Nyheterna på sidan 100, ekonomi på 200, sporten på 300 och sen blandat på 500. Det blev snudd på internationell standard.

mellanrubrik: Var med och startade 377

Dessutom var Torbjörn Jacobsson en av dem som drog igång sidan 377. För er som inte vet – sidan 377 är legendarisk. Den har nästan religiös status bland alla som gillar sport.

{.bild}
fil: texttv/texttv377.jpg
bildtext: Kärleken till text-tv och kanske framförallt sidan 377 är fortsatt stor. Tjänsten har hyllats både i Facebook och med eget konto på Twitter.
foto: SVT
storlek: wide
{}

Aftonbladets krönikör Marcus Leifby har flera gånger skrivit om sin kärlek till text-tv och framförallt sidan 377, som han kallat [”nördarnas heliga Graal” | http://bloggar.aftonbladet.se/leifby/2011/12/och-302-och-330-och/].
När sidan 377 hyllades med ett [eget konto på Twitter | https://twitter.com/SVT377] sade SVT:s sportreporter och kommentator Ola Bränholm att ”text-tv är sportnördens bästa vän”.
Tunga sportprofiler som Arne Hegerfors och Ralf Edström har berättat om hur de använder sidan i stort sett varje dag.

– Det började med gamla Tipsextra då Leif Larsson och Lars-Gunnar Björklund körde ”pling i rutan”. Det var ju jävligt populärt. Men de körde bara engelsk fotboll och inte ens hela säsongen. Vi märkte att det fanns en efterfrågan, säger Torbjörn.
– Vi hade direktkontakt med en snubbe i London, Dennis Hitchcock, som tittade på tv-bilder från matcherna och så berättade han för oss: ”nu har Middlesbrough gjort 1-0”.

mellanrubrik: Blev en supersuccé

I samband med det startade Svenska bandyförbundet en tjänst där de ringde runt till varandra från arenorna under matcherna för att uppdatera resultaten, i något som kallades ”bandyslingan”. Vi hakade på där och resultatservicen växte, berättar Torbjörn.
Till en början låg alla resultat på sidan 320 men efter att ha flyttats runt på några olika sidor så fixerades de till slut på sidan 377 – där de ligger kvar än i dag.
– Jag vet att min son satt hemma på dagarna med en kompis och tittade på sidan 377 och jag nästan skämdes för att barnen var så nördiga, men sen förstod jag ju att de var långt ifrån ensamma, säger Torbjörn.

{.bild}
fil: texttv/Redaktionen_80tal_toja.jpg
bildtext: Torbjörn gör allt möjligt. En del av framgången var att text-tv var allas nyheter. Så länge det var sant, relevant, faktabaserat och kunde berättas i ord så platsade nyheten. Bild från redaktionen på 1980-talet.
foto: Torbjörn Jacobsson
storlek: full
{}

Att text-tv blev en supersuccé var inga konstigheter, menar Torbjörn:
– Det vi skriver är viktigt, kortfattat, du får information när du vill och i den ordning du vill. Dessutom, när vi startade var det här något helt nytt, säger han.
Torbjörn Jacobsson säger att en del av framgången var att text-tv var allas nyheter.
– Vi struntade fullständigt i om det var Rapport eller Aktuellt som hade nyheten. Det är svårt att förstå hur stark den konkurrensen var på SVT under 1980-talet, redaktionerna pratade knappt med varandra. Samtidigt skrev vi på allas nyheter oavsett om det var Ekot, Dagens Nyheter, Aftonbladet eller TT som var källan.

{.citat}
citat: Det är inte en riktig nyhet om det inte stått på text-tv
stil: strong
av: Torbjörn Jacobsson
{}


Så länge det var sant, relevant, faktabaserat och kunde berättas i ord så kunde nyheten platsa på text-tv.
 – Jag vet att många som tycker att ”det inte är en riktig nyhet om det inte stått på text-tv”, säger Torbjörn.

 mellanrubrik: Lämnade text-tv – för webben

 Trots succén och alla framgångar valde Torbjörn 1996 att lämna text-tv. Då för att ägna sig åt sin andra stora kärlek – webben. Han var först projektledare för svt.se och senare var han med och byggde upp det som i dag är svtnyheter.se.
 – Jag slutade med stolthet efter vad jag upplevde som väl förrättat värv och jag hade inga tankar på att komma tillbaka, säger han.
 Torbjörn upplevde några av sina bästa år under karriären – men ändå, runt 2004 var han tillbaka på text-tv. Och man kan ju undra varför. Vad är det som gör nyheterna på text-tv så speciella, hur kan de fortfarande locka en miljonpublik, varje dag.

En sida på text-tv har inga bilder, utrymmet att skriva på är hårt begränsat: på max 14 rader med plats för 37 tecken på varje rad, totalt 518 tecken, ska allt in – när, var, hur, vem och varför måste få plats.

{.bild}
fil: texttv/text_tv_1984.jpg
bildtext: På en väldigt begränsad yta ska allt viktigt få plats. ”Det kan låta enahanda men varje sida är en ny utmaning”, säger Torbjörn Jacobsson.
foto: Torbjörn Jacobsson
storlek: texttv
{}

Nyheten ska vara korrekt och förståelig, folk ska vilja läsa och det viktigaste måste givetvis vara med.
– Det kan låta enahanda men varje sida är en ny utmaning. Det är väldigt nutidsorienterande och jag gillar att jobba med språk och uttryck. Och man sitter med överblick över hela nyhetsflödet som ska levereras till hela svenska folket, säger Torbjörn.

mellanrubrik: ”Missat de flesta stora nyheterna”


Jag frågar om han upplevt att några nyheter varit svåra att rapportera om, det här ändå hänt rätt mycket runt om i världen sedan 1980. Svaret är möjligen lite förvånande.
 – Det känns faktiskt lite konstigt men jag har missat att jobba med de flesta riktigt stora nyhetshändelserna. När Olof Palme mördades var jag barnledig. Jag var sjuk när Estonia sjönk. När tsunamin drog in över Thailand 2004 var jag julledig och jobbade bara i slutskedet, säger Torbjörn, och fortsätter:
 – När Utöya inträffade hade jag semester och sen var jag bortrest när terrorn drabbade Paris 2015, säger Torbjörn.

{.video}
id: 13458119
{}

luft:-48px
 {.citat}
 citat: Den första sida som jag minns att jag skrev handlade om mordet på John Lennon
 stil: strong
 av: Torbjörn Jacobsson
 {}

 Samtidigt – en del har han faktiskt varit med om. Torbjörn berättar om den första sidan han skrev på text-tv, som han kommer ihåg:
 – Den handlade om mordet på John Lennon. Det var den 8 december 1980. Det var lite jobbigt att skriva om.

mellanrubrik: Först att skriva om ”Guds hand”

När Torbjörn berättar om John Lennon kommer han på ytterligare en nyhet han skrev:
– Jag var faktiskt förste svenske journalisten som skrev ”att Maradona tryckte in bollen med handen”. Vi liverapporterade direkt på text-tv och jag såg bilden och tänkte ”men var inte det där med handen?”
Det Torbjörn pratar om är fotbollslegendaren Diego Armando Maradonas ökända mål mot England i VM-kvartsfinalen 1986, då Maradona boxade in bollen i mål. Målet godkändes och efter matchen förklarade Maradona att det var ”Guds hand” som hjälpt honom.

{.bild}
fil: texttv/maradona.jpg
bildtext: 12 år efter sitt ökända mål bad Maradona om ursäkt – och erkände: Det var han själv och inte Gud som gjorde 1-0-målet i hatmachen mot England i VM 1986.
storlek:square
imgix.fp-y:0
foto: AP
{}

– Direktkommenteringen är nog faktiskt det som varit roligast av allt på text-tv. Vi visste ju att många tog hjälp av textningen och tänkte att det här är användbart inom sporten. Det var vi som införde att det skulle stå resultat hela tiden under pågående matcher framförallt i ishockey och i fotboll, säger Torbjörn – och berättar ytterligare om hur text-tv redan 1992 gjorde vad nästan alla nyhets- och sportredaktioner gör i dag. Liverapporterar.
– Det var under fotbolls-EM 1992. Sverige mötte England och jag satt på Råsunda med en bärbar dator, även om den burken nog var en lite större än de datorer som finns nu, säger Torbjörn med ett leende.
– Jag liverapporterade för text-tv och Sverige gjorde ett vackert segermål. Tomas Brolin passade Jonas Thern, fick tillbaka bollen och väggspelade med Martin Dahlin. Sen avslutade Brolin med ett mål i världsklass.
{.video}
id: 13442695
bildtext: Tomas Brolins 2-1-mål tog Sverige till gruppseger och semifinal i fotbolls-EM. ”Ett av de vackraste målen jag gjort”, sade Brolin själv om sitt drömmål.
{}

– På så sätt så ser jag faktiskt på mig själv som Sveriges förste onlinejournalist. För mig spelar det inte så stor roll hur publiken tar till sig texten, om det är på text-tv eller på webben.


mellanrubrik: Läsare hotade med stämning

Men stora nyheter och fantastiska mål har bara varit en del av arbetet. Precis allt har inte varit lika kul – Torbjörn säger att arbetet kunde vara fruktansvärt manuellt.
– Vi satt och skrev in penninglotteriets siffror för hand. Det blev mycket siffror som skulle in. En gång hörde en läsare av sig och hotade med att stämma oss. Han menade att han slängt en travbong efter att ha läst resultatet på text-tv. Han menade att vi skrivit fel och kände sig lurad. Men det kom aldrig någon stämning.
En gång blev redaktionen JO-anmäld för ett aprilskämt, det var något om att den som kunde bevisa att man bara använde sin tv för att titta på text-tv och inga andra program, skulle slippa betala tv-licensen. Men Justitieombudsmannen utredde aldrig utredningen eftersom text-tv inte omfattas av JO:s tillsyn.

mellanrubrik: SVT tog livet av påven
I övrigt kan Torbjörn inte minnas några större haverier – förutom en gång, då någon på webbredaktionen [råkade ta livet av påven | http://www.expressen.se/nyheter/har-tar-svt-dod-pa-paven/]. Det var den 4 mars 2005 som Sveriges Television av misstag publicerade en dödsruna om påven Johannes Paulus II på svt.se.
Några timmar senare upptäcktes misstaget och påven återuppstod. En av dem som fick hantera och dementera nyheten var Torbjörn, som nu börjar närma sig slutet på en lång karriär.
– Jag känner mig färdigjobbad nu, men det är klart som fan att man kommer att sakna det, framförallt det sociala och den redaktionella miljön, säger han.

{.bild}
fil: texttv/TJ1.jpg
bildtext: Torbjörn Jacobsson, vid tidigt 1990-tal då han var nyhetschef för SVT Text. I bakgrunden nyhetsredaktören Kerstin Ottosson.
foto: Torbjörn Jacobsson
storlek: full
{}


Att sitta mitt i nyhetsflödet och hela tiden veta vad som hänt och vad som är på gång ger en viss känsla.
– Men jag är rätt nöjd. Jag är framme nu. Det är inte alla som kan se tillbaka och säga att de varit med om att utveckla två helt nya media. Det har jag gjort, säger Torbjörn med en viss stolthet.

mellanrubrik: Är orolig för text-tvs framtid

Samtidigt berättar att han om sin oro för framtiden, för text-tv.
– SVT förstår fortfarande inte guldägget man har i sin hand. Vid högtidliga tillfällen talas det värdigt om text-tv men samtidigt väljer man att skära ner och dra ner på personal. För mig känns det kortsiktigt och det gör mig sorgsen, säger Torbjörn.
Från början var redaktionen relativt stor, man var åtta personer totalt. Nu är arbetsdagen uppdelad i tre pass, från klockan 06 på morgonen till klockan 01 på natten. Största delen av de passen jobbar man ensam, som både redaktör och reporter.
Exakt vad Torbjörn Jacobsson anser om den allra sista nedskärningen till ensamjobb, det passar sig inte riktigt att skriva ordagrant i en text.
Men vi kan konstatera att han inte är helt nöjd.

Mellanrubrik: ”Jag tycker det är skitkonstigt”
Sedan tidigare har SVT dragit ner på text-tv:s bemanning över natten. Nu är det i stället nyhetsbyrån TT som sköter den bevakningen. Något som är helt bisarrt, om du frågar Torbjörn.
– Att ett konkurrerande nyhetsföretag får komma in och nyhetsvärdera hos oss. Jag är väldigt förvånad att det skett utan knappt någon diskussion. Vi värnar om vårt Public Service-uppdrag och så släpper vi in ett annat företag att hantera våra nyheter. Jag tycker det är skitkonstigt, säger han.

{.bild}
fil: texttv/Nostalig_inneha%CC%8All_80_tal.jpg
foto: Torbjörn Jacobsson
storlek: texttv
{}


Min sista fråga till Mr. text-tv är given: På vilken sida skulle han själv placera nyheten om sin egen pension?
– 106 såklart! Dagens viktigaste nyhet, säger han snabbt.
 Sen ändrar han sig:
 – 150 kanske, text-tv är ju kultur. Eller nej, reflexmässigt skulle det nog bli första lediga sida, säger Torbjörn Jacobsson med ett skratt.


 {.sharebuttons}
 title:Nu slutar Mr. Text-tv
 url: http://pejl.svt.se/nu-slutar-mr-text-tv
 {}

 rubrik5: Hasse Burström
 luft: -40
 [ hasse.burstrom@svt.se | mailto:hasse.burstrom@svt.se | black]

[]
`;

export default page;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/nu-slutar-mr-text-tv.js
 **/